<template>
  <v-card class="mx-auto">
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Groupes
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <v-card-text>
      {{ MembresNan.length }}
    </v-card-text>
    <v-card-actions>
      <Navigation :elements="AdminNavigation" />
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapState, mapActions } from "vuex";
import sha256 from "crypto-js/sha256";
export default {
  components: {
    Navigation: require("@/components/Navigation.vue").default,
  },
  data: () => ({
    // Filter models.
    facilitateursFilterValue: null,
    regionsFilterValue: null,
    //
    search: "",
    item: "",
    pin1: "",
    pin2: "",
    pin3: "",
    inputRules: [
      (v) => !!v || "requis",
      (v) => (v && v.length >= 3) || "Au moins trois caractères",
    ],
    id_groupe: "",
    dataToSend: {},
    setActive: false,
    nom_groupe: "",
    tarif_part: "",
    dialog: false,
    dialog_update: false,
  }),
  computed: {
    headers() {
      return [
        {
          text: "ID",
          align: "start",
          value: "id",
          label: "ID",
          field: "id",
        },
        {
          text: "Nom",
          align: "start",
          value: "nom_groupe",
          label: "Nom",
          field: "nom_groupe",
        },
        {
          text: "ID Région",
          value: "id_region",
          label: "ID Région",
          field: "id_region",
          filter: this.regionsFilter,
        },
        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
          filter: this.regionsFilter,
        },

        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },

        {
          text: "Facilitateur",
          value: "nom_responsable",
          label: "Facilitateur",
          field: "nom_responsable",
          filter: this.facilitateursFilter,
        },
        {
          text: "Projets",
          value: "projetsSlot",
        },
        {
          text: "projectList",
          value: "projectList",
        },

        {
          text: "Actions",
          value: "actions",
          sortable: false,
        },
      ];
    },
    ...mapState({
      MembresNan: (state) => state.Membres.MembresNan,
      regions: (state) => state.Regions.Regions,
      districts: (state) => state.Districts.Districts,
      pagination_clicked_count: (state) =>
        state.Groupes.pagination_clicked_count,
      disable_next: (state) => state.Groupes.disable_next,
      disable_prev: (state) => state.Groupes.disable_prev,
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
      superviseurs: (state) =>
        _.filter(state.Users.identifiants, { role: "superviseur", active: 1 }),
    }),
  },
  watch: {
    dialog(val) {
      val || this.resetInitializeGroup();
    },
  },
  created() {
    this.GetMembresNan();
  },
  mounted() {},
  methods: {
    regionsFilter(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.regionsFilterValue) {
        return true;
      }
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      return value === this.regionsFilterValue;
    },

    facilitateursFilter(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.facilitateursFilterValue) {
        return true;
      }
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      return value === this.facilitateursFilterValue;
    },

    ...mapActions({
      GetMembresNan: "Membres/GetMembresNan",
      prevPage: "Groupes/prevPage",
      nextPage: "Groupes/nextPage",
      GetRegions: "Regions/GetAll",
      GetDistricts: "Districts/GetAll",
    }),

    MembresDuGroupe(groupe) {
      this.$router.push({ name: "groupes-membres", params: { groupe } });
    },
    resetInitializeGroup() {
      this.$refs.formInitializeGroup.reset();
      this.dialog = false;
    },
    initializeGroupDialog(item) {
      this.id_groupe = item.id;
      this.nom_groupe = item.nom_groupe;
      this.tarif_part = item.tarif_part;
      this.pin1 = item.pin1;
      this.pin2 = item.pin2;
      this.pin3 = item.pin3;
      this.item = item;
      this.dialog = true;
    },
    initializeGroup() {
      if (this.$refs.formInitializeGroup.validate()) {
        //console.log(this.id_groupe);
        this.dataToSend.nom_groupe = this.nom_groupe;
        this.dataToSend.tarif_part = this.tarif_part;
        this.dataToSend.active = "1";
        /*  this.dataToSend.sac1 = 0;
          this.dataToSend.sac2 = 0;
          this.dataToSend.sac3 = 0;
          this.dataToSend.latitude = 0;
          this.dataToSend.longitude = 0; */
        this.dataToSend.pin1 = this.pin1;
        this.dataToSend.pin2 = this.pin2;
        this.dataToSend.pin3 = this.pin3;
        this.dataToSend.unlock_code = sha256(
          this.pin1 + this.pin2 + this.pin3
        ).toString();
        this.dataToSend.unlocked = false;
        console.log(this.dataToSend);
        //update dans collection groupe
        /*    let groupeRef = this.$firebase
            .firestore()
            .collection("groupes")
            .doc(this.id_groupe);
          let updateGroupe = groupeRef.update(this.dataToSend); */
        /*  //update dans collection users
          let userRef = this.$firebase
            .firestore()
            .collection("users")
            .doc(this.id_groupe);
          let updateUser = userRef.update(this.dataToSend);
          this.groupes_actifs.push(this.item);
          this.groupes.splice(this.item.id, 1); */
        this.dialog = false;
      }
    },
    deleteGroupe(item) {
      confirm("Voulez vous supprimer ce groupe?") &&
        this.desserts.splice(index, 1);
    },
    gotoDetailsGroupe(item) {
      this.$router.push({ path: `/groupe/${item.id}` });
    },
    detailsGroupe(item) {
      this.$router.push({ path: `/detailsGroupe/${item.id}` });
    },
    getActive(active) {
      if (active == "1") {
        return "Actif";
      } else {
        return "Non initialisé";
      }
    },
    print(print) {
      // Pass the element id here
      this.$htmlToPaper(print);
    },
  },
};
</script>
<style>
.map {
  height: 500px;
}
</style>
